import { BrowserRouter, Routes, Route } from "react-router-dom";

import React, { Suspense, useEffect } from "react";

import NotFound from "../pages/NotFound";

import ProtectedRoute from "./protected-route";
import routes from "./routes.json";


import { Navigate, Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from "@/hooks/useReduxHooks";
import Login from '@/pages/Login'

import VendorOnboardingProfile from '@/pages/VendorOnboardingProfile'
import Dashboard from '@/pages/Dashboard'
import VenueOnboard from '@/pages/VenueOnboard'
import SlotManager from '@/pages/SlotManager/SlotManager'


import BookingDetails from '@/pages/VenueManagement/BookingDetails'
import Bookings from '@/pages/VenueManagement/Bookings'


import VenueList from '@/pages/VenueList'

import Profile from '@/pages/Profile'
import MyWebsite from '@/pages/MyWebsite/MyWebsite'
import DirectBookingLink from '@/pages/DirectBookingLink/DirectBookingLink'
import DBLSubscription from '@/pages/DirectBookingLink/DBLSubscription'
import VenueRecommendation from '@/pages/VenueRecommendation'
const BookingReschedule = React.lazy(() => import("@/pages/VenueManagement/BookingReschedule"));

import { getVendorProfile } from '@/store/thunkMidddleware/usersMiddleware';


import AppShell from "@/components/shell/AppShell";
import OfferManagementPage from "@/pages/VenueManagement/OfferManagementPage";
import { Loader2 } from "lucide-react";



const Router = () => {
  const dispatch = useAppDispatch()
  const profileState = useAppSelector(state => state.profile)
  const authState = useAppSelector(state => state.auth);
  useEffect(() => {
    if(!profileState.vendorProfile.payload && authState.isAuthenticated){
      fetchProfile()
    }
  }, [])


  const fetchProfile = async (token?: string) => {
    dispatch(getVendorProfile({
        callback: (profile) => {
            console.log("profile:", profile)
        }
    }))
}
  return (<BrowserRouter>
    <Routes>

      {/* --------------Public routes ------------------------------------ */}
      {/* <Route path={routes.login}
        element={
          authState.isAuthenticated || authState.token ? (
            <Navigate to={window.location.pathname} replace />  // Redirect to home/dashboard if authenticated
          ) : (
            <Login />  // Show login page only if not authenticated
          )
        }
      /> */}

      <Route path={routes.login} element={<Login />} />

      {/* <Route
        path={routes.dashboard}
        element={<Suspense fallback={<DashboardSkeleton />}>  <Dashboard />  </Suspense>}
      /> */}


      {/*-------------- Protected routes --------------*/}
      <Route element={<ProtectedRoute />}>
        <Route path={routes.vendorOnboard} element={<VendorOnboardingProfile />} />

        <Route element={<AppShell />}>
          <Route path={routes.dashboard} element={<Dashboard />} />
          <Route path={routes.venueOnboard} element={<VenueOnboard />} />
          <Route path={routes.editVenueOnboardById} element={<VenueOnboard />} />
          {/* One screen serves both: the bare path picks a venue for the vendor,
              the :id form is the deep link back to a specific one. */}
          <Route path={routes.VenueManagementHome} element={<SlotManager />} />
          <Route path={routes.venueManagementByID} element={<SlotManager />} />
          <Route path={routes.offerManagement} element={<OfferManagementPage />} />

          <Route path={routes.venueBookings} element={<Bookings />} />

          <Route path={routes.venueBookingDetails} element={<BookingDetails />} />

          <Route path={routes.venueList} element={<VenueList />} />
          <Route path={routes.profile} element={<Profile />} />
          <Route path={routes.mywebsite} element={<MyWebsite />} />
          <Route path={routes.DirectBookingLink} element={<DBLSubscription />} />
          <Route path={routes.venueRecommendation} element={<VenueRecommendation />} />

      <Route path={routes.bookingRescheduleByid} 
        element={<Suspense 
        fallback={<Loader2 className="animate-spin absolute z-10 top-[50%] right-1/2 w-12 h-12 text-black/80" />  }>    
        <BookingReschedule />
          </Suspense>} 
        />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
  );
}
export default Router;
